import { useState } from "react";

export default function StatsCards() {
  const [showOverlay, setShowOverlay] = useState(false);
  const [ShowCashin, setShowCashin] = useState(false);
  const [currency, setCurrency] = useState("");
  const [amount, setAmount] = useState("");

  const currencies = ["EUR", "USD", "USDC", "USD1"];

  return (
    <div className="button-section">
      {/* PULSANTI PRINCIPALI */}
      <div className="button-container">
        <button className="main-btn cash-in"
            onClick={() => setShowCashin(true)}
        >
          Cash In
        </button>
        <button className="main-btn cash-out"
            onClick={() => setShowOverlay(true)}
        >
          Cash Out
        </button>
      </div>

      {/* OVERLAY SOLO SEZIONE */}
      {showOverlay && (
        <div
          className="section-overlay"
          onClick={() => setShowOverlay(false)}
        >
          <div
            className="overlay-box"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Withdrawal</h3>

            {/* INPUT IMPORTO */}
            <input
              type="number"
              className="amount-input"
              placeholder="Amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />

            {/* RADIO VALUTA */}
            <div className="radio-list">
              {currencies.map((value) => (
                <label key={value} className="radio-item">
                  <input
                    type="radio"
                    name="currency"
                    value={value}
                    checked={currency === value}
                    onChange={() => setCurrency(value)}
                  />
                  <span className="radio-label">{value}</span>
                </label>
              ))}
            </div>

            {/* PULSANTI MODAL */}
            <div className="modal-buttons">
              <button
                className="modal-btn cancel"
                onClick={() => setShowOverlay(false)}
              >
                Cancel
              </button>
              <button
                className="modal-btn confirm"
                onClick={() => {
                  if (!amount || !currency) {
                    alert("Insert Value and Currency");
                    return;
                  }
                  alert(`Importo: ${amount} - Valuta: ${currency}`);
                  setShowOverlay(false);
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      {ShowCashin && (
        <div
          className="section-overlay"
          onClick={() => setShowCashin(false)}
        >
          <div
            className="overlay-box"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Deposit</h3>

            {/* INPUT IMPORTO */}
            <input
              type="number"
              className="amount-input"
              placeholder="Amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />

              {/* RADIO VALUTA */}
            <div className="radio-list">
              {currencies.map((value) => (
                <label key={value} className="radio-item">
                  <input
                    type="radio"
                    name="currency"
                    value={value}
                    checked={currency === value}
                    onChange={() => setCurrency(value)}
                  />
                  <span className="radio-label">{value}</span>
                </label>
              ))}
            </div>

            {/* PULSANTI MODAL */}
            <div className="modal-buttons">
              <button
                className="modal-btn cancel"
                onClick={() => setShowCashin(false)}
              >
                Cancel
              </button>
              <button
                className="modal-btn confirm"
                onClick={() => {
                  if (!amount) {
                    alert("Insert Value and Currency");
                    return;
                  }
                  alert(`Amount: ${amount}`);
                  setShowCashin(false);
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

  
  
  
  
  